<template>
    <div>
        <modal-add-google-indexing ref="addGoogleIndexingDialog"/>
        <v-row>
            <v-col cols="2">
              <v-btn @click="showAddGoogleIndexingModal()">Dodaj adres</v-btn>
                <div>
                    <v-menu
                            v-model="menu4"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                    >
                    </v-menu>
                </div>
                <div>
                    <v-chip-group v-model="filters.status" column active-class="primary--text" multiple>
                        <v-chip v-for="(key, status) in statuses" :key="status" :value="status">
                            {{ getStatusText(status) }}
                        </v-chip>
                    </v-chip-group>
                </div>
                <v-btn @click="get();" color="primary" block>Filtruj</v-btn>
            </v-col>
            <v-col cols="10">
                <data-table
                        ref="table"
                        :headers="headers"
                        :items="items"
                        :options.sync="options"
                        :server-items-length="total"
                        :loading="loading"
                        class="elevation-1 row-pointer"
                >
                    <template v-slot:item.status="{ item }">
                        {{ getStatusText(item.status) }}
                    </template>

                    <template v-slot:item.error="{ item }">
                        {{ item.error }}
                    </template>
                </data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import api from '../services/api';
    import DataTable from "@/components/data-table/DataTable";
    import formatters from '@/mixins/formatters';
    import {getDatatableParams, setDatatableOptions, setDatatableFilters} from '@/utils/helpers';
    import {GoogleIndexingStatus, getStatusText} from '@/enums/GoogleIndexingStatus';
    import moment from 'moment';
    import permissions from '@/mixins/permissions';
    import ModalAddGoogleIndexing from "@/components/ModalAddGoogleIndexing.vue";

    export default {
        mixins: [
            formatters,
            permissions,
        ],
        components: {
          ModalAddGoogleIndexing,
          DataTable,
        },
        data () {
            return {
                statuses: GoogleIndexingStatus,
                modal: false,
                menu1: false,
                menu2: false,
                menu3: false,
                menu4: false,
                filters: {
                    status: null,
                },
                total: 0,
                items: [],
                loading: true,
                options: {},
                headers: [
                    { text: 'ID', value: 'id', sortable: false },
                    { text: 'Adres URL', value: 'url', sortable: false },
                    { text: 'Status', value: 'status', sortable: false },
                    { text: 'Błąd', value: 'error', sortable: false },
                ],
                reactOnFilterChange: true,
                stats: [],
            }
        },
        watch: {
            options: {
                handler () {
                    this.get();
                },
                deep: true,
            },
            filters: {
                handler() {
                    if (!this.reactOnFilterChange) {
                        return;
                    }

                    setDatatableFilters.call(this);
                },
                deep: true
            },

        },
        methods: {
            async showAddGoogleIndexingModal() {
              this.$refs.addGoogleIndexingDialog
                  .open()
            },
            async get() {
                this.loading = true;

                const { page, itemsPerPage } = this.options;

                if (this.filters.dateFrom) {
                    const dateFromString = String(this.filters.dateFrom).substr(0, 10);
                    this.reactOnFilterChange = false;

                    if (!moment(dateFromString).isValid()) {
                      this.filters.dateFrom = this.getDateFrom();
                    } else {
                      this.filters.dateFrom = dateFromString;
                    }

                    this.reactOnFilterChange = true;
                }

                let filters = this.filters

                if (filters.phone) {
                    filters.phone = filters.phone.replace(/\D*(\d{3})\D*(\d{3})\D*(\d{3})\D*/, '$1 $2 $3');
                }

                const params = {
                    offset: page > 1 ? itemsPerPage*(page-1) : 0,
                    ...this.filters
                };

                if (-1 !== itemsPerPage) {
                    params.limit = itemsPerPage;
                }

                if (!params.status) {
                    delete params.status;
                }

                const response = await api.get('/api/google-indexing', {params});
                this.loading = false;

                this.items = response.data.items;
                this.total = response.data.total;
                this.reactOnFilterChange = false;
                this.filters.dateFrom = response.data.dateFrom;

                setDatatableOptions.call(this);

                setTimeout(() => {
                    this.reactOnFilterChange = true;
                }, 1000); // Delay the change a bit to avoid performing another query.
            },
            getStatusText(status) {
                return getStatusText(status);
            },
        },
        created() {
            getDatatableParams.call(this);
            for (const [key] of Object.entries(this.statuses)) {
                this.stats[key] = 0;
            }
        }
    }
</script>

<style lang="css" scoped>
    .row-pointer >>> td {
      height: auto !important;
      padding: 0.5rem !important;
    }
    .row-pointer >>> tbody tr :hover {
        cursor: pointer;
    }
    .v-chip {
        white-space: break-spaces !important;
        line-height: 14px;
        width: 100%;
        padding: 9px;
    }

    .v-chip .v-chip__content {
        max-width: 100%;
        height: auto;
        overflow: auto;
        min-height: 32px;
        white-space: pre-wrap;
    }
</style>